import type { ReactNode } from "react";

export function Sidebar({ children }: { children: ReactNode }) {
  return (
    <aside className="hidden w-60 shrink-0 border-r border-slate-200 bg-white md:flex md:flex-col">
      <div className="flex h-14 items-center border-b border-slate-200 px-4">
        <span className="text-base font-semibold tracking-tight">TucsonChat</span>
      </div>
      {children}
    </aside>
  );
}
